import { useQuery } from 'react-query';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { FlowInfo } from '../types/FlowsTypes';
import { useFlowsSession } from './getFlowsSessionById';

interface Params {
  lang?: string;
}

export const getFlowInfo = async (flowId: string, params?: Params) => {
  const { data, isError } = await wgApi.get<FlowInfo>(
    `/v1/api/flows/${flowId}`,
    { query: { ...params } },
  );
  if (isError) throw new Error();
  return data;
};

const getUseFlowsInfoQKey = (flowId: string) => ['flows', 'info', flowId];

export const useFlowInfo = (flowId: string) => {
  return useQuery(getUseFlowsInfoQKey(flowId), () => getFlowInfo(flowId), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export const useFlowInfoBySessionId = (sessionId: string) => {
  const { data: session } = useFlowsSession(sessionId);
  return useFlowInfo(session?.flow_id || '');
};
